import React from 'react'
import { Outlet } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import PageTabs from '../shared/PageTabs.jsx'
import '../../styles/pages.css'

const tabs = [
  { path: '/marketing/staff-picks', label: 'Staff Picks' },
  { path: '/marketing/notify-me', label: 'Notify Me Products' },
  { path: '/marketing/abandoned-trade-forms', label: 'Abandoned trade forms' },
  { path: '/marketing/account-deletions', label: 'Account deletions', adminOnly: true },
  { path: '/marketing/trade-boost', label: 'Trade Boost', adminOnly: true },
  { path: '/marketing/referrals', label: 'Referrals', adminOnly: true }
]

function MarketingPage() {
  const { user } = useAuth()
  const visibleTabs = tabs.filter(t => !t.adminOnly || user?.is_admin)

  return (
    <div className="page">
      <div className="pageHead">
        <h1>Marketing</h1>
        <p>Curate storefront staff picks, capture relist interest and follow up abandoned trade forms</p>
      </div>

      <PageTabs tabs={visibleTabs} match="exact" />

      <div style={{ marginTop: 28 }}>
        <Outlet />
      </div>
    </div>
  )
}

export default MarketingPage
